import { CalcCounts, SortCounts } from './runtime.interfaces';

export const EMPTY_SORT_COUNTS: SortCounts = {
  prop: 0,
  aggr: 0,
  aggrTypes: [],
  calc: 0,
};

export const EMPTY_CALC_COUNTS: CalcCounts = {
  prop: [],
  aggr: [],
  calc: [],
};
